/* eslint-disable no-unused-vars */
import React, {useCallback} from "react";
import { TableBody, TableCell, TableRow } from '@material-ui/core';
import __ from "lodash";
/* eslint-enable no-unused-vars */

class MaterialTableBody extends React.Component {
  constructor() {
    super();

    this.state={
      highlightedRow: null,
      isScrolling: false,
      scrollPaddingTop: 0,
      scrollPaddingBottom: 0,
      firstVisibleRow: 0,
      lastVisibleRow: 0,
      buffersOffScreenTop: 0,
      originalRowData: null,
      editedRowData: null,
      lastDetailPanelOpen: {path:null, render:null, uuid: null},
      editMode: null
    };

    this.tbodyRef = null;

    this.setTbodyRef = element => {
      this.tbodyRef = element;
      if (this.props.forwardedRef) this.props.forwardedRef(this.tbodyRef);
    };

    this.isScrolling = false;
    //console.log('initialized');
  }
  renderEmpty(emptyRowCount, renderData) {
    const rowHeight = this.props.options.padding === "default" ? 49 : 36;
    const localization = {
      ...MaterialTableBody.defaultProps.localization,
      ...this.props.localization,
    };
    if (
      this.props.options.showEmptyDataSourceMessage &&
      renderData.length === 0 && !this.props.showAddRow
    ) {
      let addColumn = 0;
      if (this.props.options.selection) {
        addColumn++;
      }
      if (
        this.props.actions &&
        this.props.actions.filter(
          (a) => a.position === "row" || typeof a === "function"
        ).length > 0
      ) {
        addColumn++;
      }
      if (this.props.hasDetailPanel) {
        addColumn++;
      }
      if (this.props.isTreeData) {
        addColumn++;
      }
      return (
        <TableRow
          style={{
            height:
              rowHeight *
              (this.props.options.paging &&
              this.props.options.emptyRowsWhenPaging
                ? this.props.pageSize
                : 1),
          }}
          key={"empty-" + 0}
        >
          <TableCell
            style={{ paddingTop: 0, paddingBottom: 0, textAlign: "center" }}
            colSpan={this.props.columns.reduce(
              (currentVal, columnDef) =>
                columnDef.hidden ? currentVal : currentVal + 1,
              addColumn
            )}
            key="empty-"
          >
            {localization.emptyDataSourceMessage}
          </TableCell>
        </TableRow>
      );
    } else if (this.props.options.emptyRowsWhenPaging) {
      return (
        <React.Fragment>
          {[...Array(emptyRowCount)].map((r, index) => (
            <TableRow style={{ height: rowHeight }} key={"empty-" + index} />
          ))}
          {emptyRowCount > 0 && (
            <TableRow style={{ height: 1 }} key={"empty-last1"} />
          )}
        </React.Fragment>
      );
    }
  }

  onRowDataChanged(originalRowData, editedRowData) {
    this.setState({...this.state, originalRowData, editedRowData});
  }

  renderRow(data, index, key, style, isVisible, isScrolling) {
    if (data.tableData.editing || this.props.bulkEditOpen) {
      return (
        <this.props.components.EditRow
          columns={this.props.columns.filter((columnDef) => {
            return !columnDef.hidden;
          }).map((columnDef)=>{
            return {...columnDef, cellStyle: (columnDef.editCellStyle||columnDef.cellStyle||this.props.options.cellStyle)}
          })}
          components={this.props.components}
          data={data}
          errorState={this.props.errorState}
          icons={this.props.icons}
          localization={{
            ...MaterialTableBody.defaultProps.localization.editRow,
            ...this.props.localization.editRow,
            dateTimePickerLocalization: this.props.localization
              .dateTimePickerLocalization,
          }}
          key={'row-' + data.tableData.uuid}
          mode={this.props.bulkEditOpen ? "bulk" : data.tableData.editing}
          options={this.props.options}
          isTreeData={this.props.isTreeData}
          detailPanel={this.props.detailPanel}
          onEditingCanceled={this.props.onEditingCanceled}
          onEditingApproved={this.props.onEditingApproved}
          getFieldValue={this.props.getFieldValue}
          onBulkEditRowChanged={this.props.bulkEditOpen ? this.props.onBulkEditRowChanged : this.onRowDataChanged.bind(this)}
          scrollWidth={this.props.scrollWidth}
        />
      );
    } else {
         // Treeified data is using the uuid, while the grouped data used the index
         const path = this.props.isTreeData
         ? [data.tableData.uuid]
         : [index + this.props.pageSize * this.props.currentPage];
      return (
        <this.props.components.Row
          components={this.props.components}
          icons={this.props.icons}
          data={data}
          index={index}
          errorState={this.props.errorState}
          key={'row-' + data.tableData.uuid}
          level={0}
          options={this.props.options}
          localization={{
            ...MaterialTableBody.defaultProps.localization.editRow,
            ...this.props.localization.editRow,
            dateTimePickerLocalization: this.props.localization
              .dateTimePickerLocalization,
          }}
          onRowSelected={this.props.onRowSelected}
          actions={this.props.actions}
          columns={this.props.columns}
          getFieldValue={this.props.getFieldValue}
          detailPanel={this.props.detailPanel}
          path={path}
          onToggleDetailPanel={(path, render)=> {
            this.props.onToggleDetailPanel(path,render);
            if ( __.has(data, this.props.options.restoreOpenDetailPanel) && data[this.props.options.restoreOpenDetailPanel]) {
              this.setState({...this.state, lastDetailPanelOpen: {path, render: data?.tableData?.showDetailPanel, uuid: data[this.props.options.restoreOpenDetailPanel]}});
            }
          }}
          onRowClick={this.props.hasAnyEditingRow?undefined:this.props.onRowClick}
          isTreeData={this.props.isTreeData}
          onTreeExpandChanged={this.props.onTreeExpandChanged}
          onEditingCanceled={this.props.onEditingCanceled}
          onEditingApproved={this.props.onEditingApproved}
          hasAnyEditingRow={this.props.hasAnyEditingRow}
          treeDataMaxLevel={this.props.treeDataMaxLevel}
          cellEditable={this.props.cellEditable}
          onCellEditStarted={this.props.onCellEditStarted}
          onCellEditFinished={this.props.onCellEditFinished}
          scrollWidth={this.props.scrollWidth}
          isScrolling={isScrolling}
          isVisible={isVisible}
          isHighlighted={this.state.highlightedRow === index}
          highlightRow={()=>{
            !this.props.hasAnyEditingRow && this.setState({...this.state, highlightedRow: index});
          }}
        />
      );
    }
  }

  renderUngroupedRows(renderData) {
    if (this.props.addVirtualScrolling) {
      //console.log("scrollState: ", this.state.firstVisibleRow, this.state.lastVisibleRow);
      return renderData.slice(this.state.firstVisibleRow, this.state.lastVisibleRow).map((data, index) => {
        return this.renderRow(data, index+this.state.firstVisibleRow, undefined, undefined, true, this.state.isScrolling);
      });
    } else {
      return renderData.map((data, index) => {
        return this.renderRow(data, index, undefined, undefined, true, false);
      });
    }
  }

  rowRenderer (props) {
    return ({ index, key, style, isVisible, isScrolling }) => {
      const Row = this.renderRow(props.renderData[index], index, key, style, isVisible, isScrolling);
      return (
        <div
          key={key}
          style={{ ...style, display: "table", tableLayout: "fixed" }}
        >{Row}</div>
      )
    }
  }

  renderGroupedRows(groups, renderData) {
    return renderData.map((groupData, index) => (
      <this.props.components.GroupRow
        actions={this.props.actions}
        cellEditable={this.props.cellEditable}
        columns={this.props.columns}
        components={this.props.components}
        detailPanel={this.props.detailPanel}
        getFieldValue={this.props.getFieldValue}
        groupData={groupData}
        groups={groups}
        hasAnyEditingRow={this.props.hasAnyEditingRow}
        icons={this.props.icons}
        isTreeData={this.props.isTreeData}
        key={groupData.value == null ? '' + index : groupData.value}
        level={0}
        localization={{
          ...MaterialTableBody.defaultProps.localization.editRow,
          ...this.props.localization.editRow,
          dateTimePickerLocalization: this.props.localization
            .dateTimePickerLocalization
        }}
        onBulkEditRowChanged={this.props.onBulkEditRowChanged}
        onCellEditFinished={this.props.onCellEditFinished}
        onCellEditStarted={this.props.onCellEditStarted}
        onEditingApproved={this.props.onEditingApproved}
        onEditingCanceled={this.props.onEditingCanceled}
        onGroupExpandChanged={this.props.onGroupExpandChanged}
        onRowClick={this.props.onRowClick}
        onGroupSelected={this.props.onGroupSelected}
        onRowSelected={this.props.onRowSelected}
        onToggleDetailPanel={this.props.onToggleDetailPanel}
        onTreeExpandChanged={this.props.onTreeExpandChanged}
        options={this.props.options}
        path={[index + this.props.pageSize * this.props.currentPage]}
        scrollWidth={this.props.scrollWidth}
        treeDataMaxLevel={this.props.treeDataMaxLevel}
      />
    ));
  }

  stoppedScrolling = __.debounce((params)=> {
//    console.log(`stopped scrolling`);
    this.setState({...this.state, isScrolling: false});
  },150);

  scrollAtEnd = __.debounce((params)=> {
    if (params.dataLength !== this.lastRequested) {
      console.log('requesting more data', this.lastRequested, params.dataLength);
      this.lastRequested = params.dataLength;
      if (this.props.options.onScrollAtEnd) this.props.options.onScrollAtEnd(params);  
    }
  },150);

  handleScrollEvent = __.throttle((e) => {
    //console.log('scrollEventFired');
    if (this.tbodyRef) {
//      const rowHeight = this.props.rowHeight || 46;
      const rowHeight = this.props.options.padding === "default" ? 49 : 36;
      const filterRowHeight = this.props.options.filtering?this.props.filterRowHeight||rowHeight||46: 0;
      const overscanRowCount = this.props.overscanRowCount;
      const clientHeight = this.tbodyRef.clientHeight;
      const scrollTop = this.tbodyRef.scrollTop;
      const rowsOffScreenTop = Math.floor(scrollTop / rowHeight);
      const rowsOnScreen = Math.ceil(clientHeight / rowHeight);
      // const rowsOffScreenBottom = this.props.renderData.length - (rowsOffScreenTop + rowsOnScreen);
      const firstVisibleRow = rowsOffScreenTop - overscanRowCount > 0 ? rowsOffScreenTop - overscanRowCount : 0;
      const scrollPaddingTop = (firstVisibleRow ? (firstVisibleRow - 1) * rowHeight: 0)+filterRowHeight;
      const lastVisibleRow = firstVisibleRow + overscanRowCount + rowsOnScreen + overscanRowCount > this.props.renderData.length ? this.props.renderData.length : firstVisibleRow + overscanRowCount + rowsOnScreen + overscanRowCount;
      const scrollPaddingBottom = (this.props.renderData.length - lastVisibleRow) * rowHeight;
      // if (lastVisibleRow === 0) debugger;
      // const buffersOffScreenTop = rowsOffScreenTop ^ overscanRowCount;
      if (this.props.renderData.length && lastVisibleRow >= this.props.renderData.length) this.scrollAtEnd({lastVisibleRow, dataLength: this.props.renderData.length, scrollTop: this.tbodyRef.scrollTop});


      if (!this.state.isScrolling || scrollPaddingTop !== this.state.scrollPaddingTop){
        this.setState({...this.state, scrollPaddingTop, scrollPaddingBottom, firstVisibleRow, lastVisibleRow, isScrolling: true});
      }
      this.stoppedScrolling(true);
      // this.stoppedScrolling(true);
      // this.stoppedScrolling(true);
    }
  }, 10);

  componentDidMount() {
    if (this.tbodyRef && this.props && this.props.renderData ) {//&& this.props !== oldProps
      let highlightedRow = null;
      let callBacks = [];
      let lastDetailPanelOpen = this.state.lastDetailPanelOpen;
      this.props.renderData.forEach(rowData => {
        if (this.props.options.disableSelection === true || this.props.options.disableSelection === false) {
          rowData.tableData['disabled'] = this.props.options.disableSelection;
        } else if (typeof this.props.options.disableSelection === 'function') {
          rowData.tableData['disabled'] = this.props.options.disableSelection(rowData);
        }
        if (this.props.options.restoreOpenDetailPanel){
          if (lastDetailPanelOpen && __.has(rowData, this.props.options.restoreOpenDetailPanel) && rowData[this.props.options.restoreOpenDetailPanel] === lastDetailPanelOpen.uuid) {
            rowData.tableData['showDetailPanel'] = this.state.lastDetailPanelOpen.render;
          } else {
            rowData.tableData['showDetailPanel'] = undefined;
          }
        }
      });

      const rowHeight = this.props.rowHeight || 46;
      const filterRowHeight = this.props.options.filtering?this.props.filterRowHeight||rowHeight||46: 0;
      const overscanRowCount = this.props.overscanRowCount;
      const clientHeight = this.tbodyRef.clientHeight;
      const scrollTop = this.props.options.scrollTop||this.tbodyRef.scrollTop;
      const rowsOffScreenTop = Math.floor(scrollTop / rowHeight);
      const rowsOnScreen = Math.ceil(clientHeight / rowHeight);
      // const rowsOffScreenBottom = this.props.renderData.length - (rowsOffScreenTop + rowsOnScreen);
      const firstVisibleRow = rowsOffScreenTop - overscanRowCount > 0 ? rowsOffScreenTop - overscanRowCount : 0;
      const scrollPaddingTop = (firstVisibleRow ? (firstVisibleRow - 1) * rowHeight: 0)+filterRowHeight;
      const lastVisibleRow = firstVisibleRow + overscanRowCount + rowsOnScreen + overscanRowCount > this.props.renderData.length ? this.props.renderData.length : firstVisibleRow + overscanRowCount + rowsOnScreen + overscanRowCount;
      const scrollPaddingBottom = (this.props.renderData.length - lastVisibleRow) * rowHeight;
      // if (this.props !== oldProps || lastVisibleRow !== this.state.lastVisibleRow) {
      //  console.log('setting mount state:', firstVisibleRow, lastVisibleRow, clientHeight);
      // console.log('mounted MT');
        this.setState({...this.state, scrollPaddingTop, scrollPaddingBottom, firstVisibleRow, lastVisibleRow, isScrolling: false, highlightedRow, lastDetailPanelOpen}, () => {
          if (callBacks && callBacks.length > 0) {
            callBacks.forEach((callBack)=>{
              callBack(this.state);
            });
          }
        });
      // }
    }
//    console.log('Adding scroll listener');
    if (this.tbodyRef && this.props.addVirtualScrolling) {
      let count = 0;
      const restoreScroll = () => {
        if (count < 100){
          count++;
          try {
            this.tbodyRef.scrollTo(0, this.props.options.scrollTop);
            console.log(this.tbodyRef.scrollTop);  
          } catch (err) {
            console.log(err);
            setTimeout(restoreScroll, 5);
          }
        } else {
          console.error('aborting restore of scroll');
        }
      }

      if (this.props.options.scrollTop) {
        setTimeout(restoreScroll, 5);
        this.tbodyRef.addEventListener('scroll', this.handleScrollEvent.bind(this));
      } else {
        this.tbodyRef.addEventListener('scroll', this.handleScrollEvent.bind(this));
      }
    }
  }

  componentDidUpdate(oldProps) {
    if (this.props && this.props.renderData && this.props !== oldProps ) {
      if (this.props.isTreeData && typeof this.props.options.autoExpandTree === 'function') {
        this.props.renderData.forEach(rowData => {
          if (this.props.options.autoExpandTree(rowData) === true && rowData.tableData.autoExpandInitialized === undefined) {
            rowData.tableData['isTreeExpanded'] = true;
            rowData.tableData['autoExpandInitialized'] = true;
          }
        })
      }
    }
    if (this.tbodyRef && this.props && this.props.renderData && this.props !== oldProps ) {
      let highlightedRow = this.state.highlightedRow;
      if (this.props.renderData !== oldProps.renderData && highlightedRow) {
        highlightedRow = null;
      }
      let callBacks = [];
      let lastDetailPanelOpen = this.state.lastDetailPanelOpen;
      let found = false;
      this.props.renderData.forEach(rowData => {
        if (this.props.options.disableSelection === true || this.props.options.disableSelection === false) {
          rowData.tableData['disabled'] = this.props.options.disableSelection;
        } else if (typeof this.props.options.disableSelection === 'function') {
          rowData.tableData['disabled'] = this.props.options.disableSelection(rowData);
        }
        if (this.props.options.restoreOpenDetailPanel){
          if (lastDetailPanelOpen && __.has(rowData, this.props.options.restoreOpenDetailPanel) && rowData[this.props.options.restoreOpenDetailPanel] === lastDetailPanelOpen.uuid) {
            rowData.tableData['showDetailPanel'] = this.state.lastDetailPanelOpen.render;
            found = true;
          } else {
            rowData.tableData['showDetailPanel'] = undefined;
          }
        }
      });
      if (!found && this.props.options.restoreOpenDetailPanel && lastDetailPanelOpen.uuid) {lastDetailPanelOpen = {path:null, render:null, uuid: null}}
      //const rowHeight = this.props.rowHeight || 46;
      const rowHeight = this.props.options.padding === "default" ? 49 : 36;
      const filterRowHeight = this.props.options.filtering?this.props.filterRowHeight||rowHeight||46: 0;
      const overscanRowCount = this.props.overscanRowCount;
      const clientHeight = this.tbodyRef.clientHeight;
      const scrollTop = this.props.options.scrollTop||this.tbodyRef.scrollTop;
      const rowsOffScreenTop = Math.floor(scrollTop / rowHeight);
      const rowsOnScreen = Math.ceil(clientHeight / rowHeight);
      // const rowsOffScreenBottom = this.props.renderData.length - (rowsOffScreenTop + rowsOnScreen);
      const firstVisibleRow = rowsOffScreenTop - overscanRowCount > 0 ? rowsOffScreenTop - overscanRowCount : 0;
      const scrollPaddingTop = (firstVisibleRow ? (firstVisibleRow - 1) * rowHeight: 0)+filterRowHeight;
      const lastVisibleRow = firstVisibleRow + overscanRowCount + rowsOnScreen + overscanRowCount > this.props.renderData.length ? this.props.renderData.length : firstVisibleRow + overscanRowCount + rowsOnScreen + overscanRowCount;
      const scrollPaddingBottom = (this.props.renderData.length - lastVisibleRow) * rowHeight;
      const editMode=(this.props.hasAnyEditingRow?this.props.showAddRow?'add':'update':null);
      const editModeChanged = this.state.editMode !== editMode;
      // console.log('setting state');
      this.setState({...this.state, scrollPaddingTop, scrollPaddingBottom, firstVisibleRow, lastVisibleRow, isScrolling: false, highlightedRow, lastDetailPanelOpen, editMode}, () => {
        if (callBacks && callBacks.length > 0) {
          callBacks.forEach((callBack)=>{
            callBack(this.state);
          });
        }
        if (editModeChanged && this.props.options.onEditModeChanged) {
          this.props.options.onEditModeChanged(editMode);
        }
      });
    }
  }

  componentWillUnmount() {
//    console.log('Removing scroll listener');
    if (this.tbodyRef) {
      this.tbodyRef.removeEventListener('scroll', this.handleScrollEvent.bind(this) );
    }
  }


  render() {
    let renderData = this.props.renderData;
    const groups = this.props.columns
      .filter((col) => col.tableData.groupOrder > -1)
      .sort(
        (col1, col2) => col1.tableData.groupOrder - col2.tableData.groupOrder
      );

    let emptyRowCount = 0;
    if (this.props.options.paging) {
      emptyRowCount = this.props.pageSize - renderData.length;
    }

    const FilterRowStyleScroll = {
      position: "absolute",
      paddingLeft: (this.props.options.selection?30:0),
      width: `calc(100% - ${20 + (this.props.options.selection?30:0)}px)`,
      maxWidth: `calc(100% - ${20 + (this.props.options.selection?30:0)}px)`,
      height: this.props.filterRowHeight||this.props.rowHeight||46,
      top: this.props.headerHeight?this.props.headerHeight : 36,
      background: "#ffffff",
      zIndex: 10,
    }
    const filtersDisabled = {};
    if (this.props.hasAnyEditingRow) {
      filtersDisabled['disabled']=true;
    }

    const showButtonBar = this.props && this.props.components && this.props.components.hasOwnProperty('ButtonBar');

    const Filter = this.props.options.filtering && (
      <this.props.components.FilterRow
        columns={this.props.columns.filter(
          (columnDef) => !columnDef.hidden
        )}
        icons={this.props.icons}
        hasActions={
          !showButtonBar && this.props.actions.filter(
            (a) => a.position === "row" || typeof a === "function"
          ).length > 0
        }
        actionsColumnIndex={this.props.options.actionsColumnIndex}
        onFilterChanged={this.props.onFilterChanged}
        selection={this.props.options.selection}
        localization={{
          ...MaterialTableBody.defaultProps.localization.filterRow,
          ...this.props.localization.filterRow,
          dateTimePickerLocalization: this.props.localization
            .dateTimePickerLocalization,
        }}
        hasDetailPanel={!!this.props.detailPanel}
        detailPanelColumnAlignment={
          this.props.options.detailPanelColumnAlignment
        }
        isTreeData={this.props.isTreeData}
        filterCellStyle={{...this.props.options.filterCellStyle, ...filtersDisabled}}
        filterRowStyle={{...this.props.addVirtualScrolling?{...FilterRowStyleScroll, ...this.props.options.filterRowStyle}:this.props.options.filterRowStyle}}
        hideFilterIcons={this.props.options.hideFilterIcons}
        scrollWidth={this.props.scrollWidth}
      />
    );

    const NewRowTop = this.props.showAddRow &&
      this.props.options.addRowPosition === "first" && (
        <this.props.components.EditRow
          columns={this.props.columns.filter((columnDef) => {
            return !columnDef.hidden;
          }).map(columnDef => {
            return {...columnDef, cellStyle: (columnDef.editCellStyle||columnDef.cellStyle||this.props.options.cellStyle)}
          })}
          data={this.props.initialFormData}
          components={this.props.components}
          errorState={this.props.errorState}
          icons={this.props.icons}
          key="key-add-row"
          mode="add"
          localization={{
            ...MaterialTableBody.defaultProps.localization.editRow,
            ...this.props.localization.editRow,
            dateTimePickerLocalization: this.props.localization
              .dateTimePickerLocalization,
          }}
          options={this.props.options}
          isTreeData={this.props.isTreeData}
          detailPanel={this.props.detailPanel}
          onEditingCanceled={this.props.onEditingCanceled}
          onEditingApproved={this.props.onEditingApproved}
          getFieldValue={this.props.getFieldValue}
          scrollWidth={this.props.scrollWidth}
          onBulkEditRowChanged={this.onRowDataChanged.bind(this)}
        />
      );

      const NewRowBottom = this.props.showAddRow &&
      this.props.options.addRowPosition === "last" && (
        <this.props.components.EditRow
          columns={this.props.columns.filter((columnDef) => {
            return !columnDef.hidden;
          }).map(columnDef => {
            return {...columnDef, cellStyle: (columnDef.editCellStyle||columnDef.cellStyle||this.props.options.cellStyle)}
          })}
          data={this.props.initialFormData}
          components={this.props.components}
          errorState={this.props.errorState}
          icons={this.props.icons}
          key="key-add-row"
          mode="add"
          localization={{
            ...MaterialTableBody.defaultProps.localization.editRow,
            ...this.props.localization.editRow,
            dateTimePickerLocalization: this.props.localization
              .dateTimePickerLocalization,
          }}
          options={this.props.options}
          isTreeData={this.props.isTreeData}
          detailPanel={this.props.detailPanel}
          onEditingCanceled={this.props.onEditingCanceled}
          onEditingApproved={this.props.onEditingApproved}
          getFieldValue={this.props.getFieldValue}
          scrollWidth={this.props.scrollWidth}
          onBulkEditRowChanged={this.onRowDataChanged.bind(this)}
        />
      );

    const ScrollingRowTop = this.props.addVirtualScrolling && (
      <TableRow style={{ height: this.state.scrollPaddingTop }} key={"scrollpadding-top"}/>
    );
    const ScrollingRowBottom = this.props.addVirtualScrolling && (
      <TableRow style={{ height: this.state.scrollPaddingBottom }} key={"scrollpadding-bottom"}/>
    );

    const SummaryRow = this.props.components.SummaryRow && (
      <this.props.components.SummaryRow
        data={this.props.renderData}
        columns={this.props.columns}
        options={this.props.options}
        components={this.props.components}
      />
    );

    const ButtonBar = this.props.components.ButtonBar && (
      <this.props.components.ButtonBar
        columns={this.props.columns}
        manager={this.props.options?.tableRef?.current}
        buttons={this.props.options?.buttons}
        options={this.props.options}
        components={this.props.components}
        row={(this.state.highlightedRow !== null && this.props.renderData)?__.find(this.props.renderData, {tableData:{id:this.state.highlightedRow}}):null}
        highlightedRow={this.state.highlightedRow}
        editing={this.props.hasAnyEditingRow}
        mode={this.props.hasAnyEditingRow?this.props.showAddRow?'add':'update':null}
        originalRowData={!this.props.hasAnyEditingRow || this.props.showAddRow?null:this.state.originalRowData}
        editedRowData={this.props.hasAnyEditingRow ? this.state.editedRowData : null}
      />
    );

    let scrollProps = (renderData.length > 0 || this.props.showAddRow)?{overflowY: "scroll", display: "block", width: "100%"}:{};
    const rowHeight = this.props.options.padding === "default" ? 49 : 36;

    let bodyStyle = this.props.addVirtualScrolling?{height: this.props.bodyHeight? this.props.bodyHeight - (this.props.buttonBarHeight||(this.props.components.ButtonBar?36:0)) : (((renderData.length + (this.props.showAddRow?1:0)||1)) * (this.props.rowHeight||rowHeight)) + (this.props.hasAnyEditingRow?12 + (this.props.extraEditHeight||0):0) , ...scrollProps}:{};

    return (
      <>
      <TableBody ref={this.setTbodyRef} style={bodyStyle}>
        {ScrollingRowTop}
        {Filter}
        {NewRowTop}
        {groups.length > 0
        ? this.renderGroupedRows(groups, renderData)
        : this.renderUngroupedRows(renderData)}
        {NewRowBottom}
        {this.renderEmpty(emptyRowCount, renderData)}
        {this.props.placeHolder}
        {ScrollingRowBottom}
        {SummaryRow}
      </TableBody>
      {!this.props.addVirtualScrolling && this.props.extraEditHeight ? <div style={{height: this.props.extraEditHeight}}/> : null}
      {ButtonBar}
      </>
    );
  }
}

MaterialTableBody.defaultProps = {
  actions: [],
  currentPage: 0,
  pageSize: 5,
  renderData: [],
  selection: false,
  localization: {
    emptyDataSourceMessage: "No records to display",
    filterRow: {},
    editRow: {},
  },
};

export default MaterialTableBody;
